import React from "react";
import CodeMirror from "@uiw/react-codemirror";
import { html } from "@codemirror/lang-html";
import { oneDark } from "@codemirror/theme-one-dark";

export default function HtmlCodeEditor({
                                           value,
                                           onChange,
                                           height = "400px",
                                           theme = oneDark,
                                           readOnly = false,
                                           errors,
                                           name
                                       }) {
    return (
        <div>
            <div style={{ background: theme === oneDark ? "#1e1e1e" : "#fff", padding: 8 }}>
                <CodeMirror
                    value={value}
                    height={height}
                    theme={theme}
                    extensions={[html()]}
                    editable={!readOnly}
                    onChange={(val) => onChange && onChange(val)}
                />
            </div>
            {errors && errors[name] && (
                <span className="fs-9 fw-bold text-danger">{errors[name].message}</span>
            )}
        </div>
    );
}
